import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsAdvancedMultiSelectModule } from '@lcs/shared/advanced-multi-select';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { EntitySelectModule } from '../entity-select/entity-select.module';
import { SelectModule } from '../entity-select/select/select.module';
import { LcsSingleSelectModule } from '../entity-select/single-select/single-select.module';
import { CallHistoryFilterComponent } from './call-history-filter.component';

@NgModule({
   declarations: [CallHistoryFilterComponent],
   exports: [CallHistoryFilterComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatNativeDateModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      MatOptionModule,
      LcsResponsiveTableModule,
      EntitySelectModule,
      MatButtonModule,
      MatFormFieldModule,
      LcsDatepickerModule,
      FormsModule,
      ReactiveFormsModule,
      MatNativeDateModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      SelectModule,
      MatSelectModule,
      LcsSingleSelectModule,
      MatSlideToggleModule,
      AddSpacesPipeModule,
      LcsAdvancedMultiSelectModule,
   ],
})
export class CallHistoryFilterModule {}
